import React from "react";
import "./CsrPage.css";
import BannerImage from "../Component/CSR.avif"; // ✅ Replace with your actual banner image

const CsrPage = () => {
  return (
    <div className="csr-page">
      {/* 🔹 Banner Section */}
      <div className="csr-banner">
        <img src={BannerImage} alt="CSR Banner" className="banner-img" />
      
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 csr-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About CSR (Corporate Social Responsibility Programs)
        </h2>

        <p>
          Corporate Social Responsibility (CSR) initiatives play a vital role in building a more
          inclusive and skilled society. Through CSR partnerships, CPIT collaborates with leading
          organizations and corporations to provide free or subsidized training programs for
          underprivileged youth. These initiatives are focused on promoting digital literacy,
          technical education, and employability skills that empower individuals to lead
          sustainable and independent lives.
        </p>

        <p>
          CPIT’s CSR-based programs are designed to bridge the educational and digital gap by
          offering hands-on skill development courses in areas like Information Technology,
          Accounting, Communication, and Office Management. Each course is carefully structured to
          provide practical learning experiences, ensuring students gain the technical and soft
          skills necessary to meet industry standards and professional demands.
        </p>

        <p>
          In partnership with socially responsible corporations, CPIT organizes training drives,
          workshops, and community outreach programs in rural and semi-urban areas. These efforts
          aim to reach students and job-seekers who may not have access to mainstream education
          opportunities. By making training more accessible and affordable, CPIT contributes
          directly to national missions like “Digital India” and “Skill India.”
        </p>

        <p>
          The CSR initiatives at CPIT go beyond training—they focus on real impact. Many participants
          successfully secure employment, start small businesses, or pursue higher education. By
          combining education with empowerment, CPIT’s CSR programs continue to uplift communities,
          foster social responsibility, and build a skilled, self-reliant India.
        </p>
      </div>
    </div>
  );
};

export default CsrPage;
